import React, { createContext, useEffect } from 'react';
import type { Options as PusherOptions } from 'pusher-js';
import Pusher from 'pusher-js';

import { config } from '@/config';
import axios from '@/lib/v2/axios';
import { useUser } from '@/hooks/v2/use-user';

export interface PusherContextValue {
  pusher: Pusher;
}

// Module-level variable to hold our singleton instance
let pusherInstance: Pusher | null = null;

export const PusherContext = createContext<PusherContextValue | null>(null);

interface PusherProviderProps {
  children: React.ReactNode;
  pusherKey: string;
  pusherCluster: string;
  authEndpoint?: string;
}

export const PusherProvider: React.FC<PusherProviderProps> = ({
  children,
  pusherKey,
  pusherCluster,
  authEndpoint = `${config.api.base}/broadcasting/auth`,
}) => {
  if (!pusherInstance) {
    const options: PusherOptions = {
      cluster: pusherCluster,
      authEndpoint,
    };

    pusherInstance = new Pusher(pusherKey, options);
    console.log('Created new Pusher instance:', pusherInstance);
  } else {
    console.log('Using existing Pusher instance:', pusherInstance);
  }

  useEffect(() => {
    return () => {
      // pusherInstance?.disconnect();
    };
  }, []);

  return <PusherContext.Provider value={{ pusher: pusherInstance }}>{children}</PusherContext.Provider>;
};
